/** Wandelt Spotify-Links, URIs oder blanke IDs in eine kanonische URI um. */
export function normalizeSpotifyUri(input: string): string | null {
  const value = input.trim();
  if (!value) return null;

  if (/^spotify:(album|track|show|episode|playlist|audiobook):[A-Za-z0-9]+$/.test(value)) {
    return value;
  }

  try {
    const url = new URL(value);
    if (!/(^|\.)spotify\.com$/.test(url.hostname)) return null;
    const segments = url.pathname.split('/').filter(Boolean);
    // Laenderpraefix wie /intl-de/ entfernen
    const typeIndex = segments.findIndex((segment) =>
      ['album', 'track', 'show', 'episode', 'playlist'].includes(segment),
    );
    if (typeIndex === -1) return null;
    const type = segments[typeIndex];
    const id = segments[typeIndex + 1];
    if (!type || !id) return null;
    return `spotify:${type}:${id.split('?')[0]}`;
  } catch {
    return null;
  }
}

export function uriType(uri: string): string | null {
  return uri.split(':')[1] ?? null;
}

/** Kontext-URIs sind Sammlungen; Tracks/Episoden werden als uris uebergeben. */
export function isContextUri(uri: string): boolean {
  const type = uriType(uri);
  return type === 'album' || type === 'playlist' || type === 'show';
}

export function formatDuration(ms: number | null | undefined): string {
  if (ms === null || ms === undefined || !Number.isFinite(ms)) return '–';
  const totalSeconds = Math.floor(ms / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  const pad = (n: number) => String(n).padStart(2, '0');
  return hours > 0 ? `${hours}:${pad(minutes)}:${pad(seconds)}` : `${minutes}:${pad(seconds)}`;
}
